<template>
    <div class="wrapper">
        <div class="content">
            <!--tab新闻列表-->
            <div class="news-wrap">
                <NewsTab :title1="newsArr[0]" :newsClass_1="newsClass[0]" :cate_id1="newsCate[0]"></NewsTab>
                <NewsTab :title1="newsArr[1]" :newsClass_1="newsClass[1]" :cate_id1="newsCate[1]"></NewsTab>
                <NewsTab :title1="newsArr[2]" :newsClass_1="newsClass[2]" :cate_id1="newsCate[2]"></NewsTab>
            </div>
            <div class="content-left" v-if="false">
                <!--投诉榜下方广告-->
                <!--<a class="guanggao" :href="images.dirlink" target="_blank"-->
                <!--v-if="images.logo.substring(images.logo.length-3,images.logo.length)==='swf'">-->
                <!--<object data="" type="">-->
                <!--<embed class="guanggao-img" :src="images.logo" type="">-->
                <!--</object>-->
                <!--</a>-->
                <a class="guanggao" :href="images.dirlink" target="_blank">
                    <img class="guanggao-img" :src="images.logo" alt>
                </a>
                <!--分类新闻列表-->
                <div class="news-wrap">
                    <NewsModule :info="market" title="市场" :active="true" :more="true" :type="4"></NewsModule>
                    <NewsModule :info="inspect" title="监督" :active="true" :more="true" :type="5"></NewsModule>
                </div>
                <!--tab新闻列表-->
                <div class="news-wrap">
                    <NewsTab :title1="newsArr[0]" :title2="newsArr[1]" :newsClass_1="newsClass[0]" :newsClass_2="newsClass[1]"></NewsTab>
                    <NewsTab :title1="newsArr[2]" :title2="newsArr[3]" :newsClass_1="newsClass[2]" :newsClass_2="newsClass[3]"></NewsTab>
                    <NewsTab :title1="newsArr[4]" :title2="newsArr[5]" :newsClass_1="newsClass[4]" :newsClass_2="newsClass[5]"></NewsTab>
                    <NewsTab :title1="newsArr[6]" :title2="newsArr[7]" :newsClass_1="newsClass[6]" :newsClass_2="newsClass[7]"></NewsTab>
                </div>
            </div>
            <!--右方看山东新闻列表-->
            <div class="content-right" v-if="false">
                <div class="wrap">
                    <div class="head">
                        <router-link class="kanshandong" :to="{path:'/ArticleList',query:{cateTitle:'看山东'}}">看山东</router-link>
                        <router-link class="kanshandong" :to="{path:'/ArticleList',query:{cateTitle:'看山东'}}">
                            <span class="more-news">MORE></span>
                        </router-link>
                    </div>
                    <div class="news-list">
                        <div :key="index" v-for="(item, index) in view_sd">
                            <router-link v-if="item.type===2" class="first-news" :to="{ name: 'complainInfo', query: { id: item.id,cateTitle:'看山东'}}" tag="div">
                                <img v-show="item.logo!==''" :src="item.logo" alt>
                                <router-link style="width:320px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" :to="{ name: 'complainInfo', query: { id: item.id,cateTitle:'看山东'}}">{{item.title}}</router-link>
                            </router-link>
                            <router-link v-else class="first-news" :to="{ name: 'article', query: { id: item.id,cateTitle:'看山东'}}" tag="div">
                                <img v-show="item.logo!==''" :src="item.logo" alt>
                                <router-link style="width:320px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" :to="{ name: 'article', query: { id: item.id,cateTitle:'看山东'}}">{{item.title}}</router-link>
                            </router-link>
                        </div>
                    </div>
                </div>
                <!--广告 看山东下方-->
                <div style="margin-bottom:57px;">
                    <a class="guanggao" :href="smAds.dirlink" target="_blank" v-if="smAds.logo.substring(smAds.logo.length-3,smAds.logo.length)==='swf'">
                        <object data type>
                            <embed class="zhanwang" :src="smAds.logo" type>
                        </object>
                    </a>
                    <a style="display: block;" :href="smAds.dirlink" target="_blank" class="zhanwang-wrap" v-else>
                        <img class="zhanwang" :src="smAds.logo">
                    </a>
                </div>
                <!--新闻栏-->
                <NewsTab :title1="newsArr[8]" :title2="newsArr[9]" :newsClass_1="newsClass[8]" :newsClass_2="newsClass[9]"></NewsTab>
                <!--多方会谈-->
                <div class="zhanlue-wrap">
                    <span class="zhanlue-text">—— 多方会谈 ——</span>
                    <div class="gundong">
                        <swiper :options="swiperOptionC">
                            <swiper-slide v-for="(item, index) in ad_three" :key="index">
                                <!-- <a
                                  :href="item.dirlink"
                                  target="_blank"
                                  v-if="item.logo.substring(item.logo.length-3,item.logo.length)==='swf'"
                                >
                                  <object data type>
                                    <embed class="img-swiper" :src="item.logo" type>
                                  </object>
                                </a>-->
                                <a :href="item.dirlink" style="display: inline-block" target="_blank">
                                    <img class="img-swiper" :src="item.logo" alt>
                                </a>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
            </div>
        </div>
        <HejieSwiper>
            <!--多方会谈-->
            <div class="zhanlue-wrap">
                <span class="zhanlue-text">—— 多方会谈 ——</span>
                <div class="gundong">
                    <swiper :options="swiperOptionC">
                        <swiper-slide v-for="(item, index) in ad_three" :key="index">
                            <!-- <a
                  :href="item.dirlink"
                  target="_blank"
                  v-if="item.logo.substring(item.logo.length-3,item.logo.length)==='swf'"
                >
                  <object data type>
                    <embed class="img-swiper" :src="item.logo" type>
                  </object>
                </a>-->
                            <a :href="item.dirlink" style="display: inline-block" target="_blank">
                                <img class="img-swiper" :src="item.logo" alt>
                            </a>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </HejieSwiper>
    </div>
</template>
<script>
import NewsModule from "@/components/NewsModule.vue";
import NewsTab from "@/components/NewsTab.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import HejieSwiper from "@/components/HejieSwiper.vue";

export default {
    name: "HomeMain.vue",
    data() {
        return {
            smAds: "",
            ad_three: "",
            images: "",
            newsClass: [],
            newsCate: [],
            view_sd: {},
            market: "",
            inspect: "",
            swiperOptionC: {
                slidesPerView: 5,
                spaceBetween: 10,
                slidesPerGroup: 1,
                loop: true,
                direction: "vertical",
                loopFillGroupWithBlank: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                speed: 4000,
                autoplay: {
                    delay: 0,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                }
            },
            newsArr: []
        };
    },
    mounted: function() {
        this.getArticle();
        this.getNewsClass();
        this.guangGao();
    },
    methods: {
        getArticle() {
            this.$get("/index/index/article")
                .then(res => {
                    if (res.code === 0) {
                        this.view_sd = res.data.view_sd;
                        this.market = res.data.market;
                        this.inspect = res.data.inspect;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        // 获取16个分类新闻
        getNewsClass() {
            this.$get("/index/index/complaint_list")
                .then(res => {
                    if (res.code === 0) {
                        for (let k in res.data) {
                            this.newsArr.push(k);
                            this.newsClass.push(res.data[k]);
                            this.newsCate.push(res.data2[k])
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        guangGao() {
            this.$get("/index/index/ad_position")
                .then(res => {
                    if (res.code === 0) {
                        this.images = res.data.images[2];
                        this.ad_three = res.data.ad_three;
                        this.smAds = res.data.sm_ads[4];
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    components: {
        NewsModule,
        NewsTab,
        swiper,
        swiperSlide,
        HejieSwiper
    }
};
</script>
<style scoped lang="less">
.wrapper {
    width: 1200px;
    margin: 0 auto;
}

.content {
    display: flex;
}

.content-left {
    width: 790px;
}

.news-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.guanggao-img {
    width: 790px;
    height: 100px;
    margin-top: 30px;
}

.content-right {
    margin-left: 25px;
    margin-top: 8px;
}

.wrap {
    width: 350px;
    margin: 26px 16px 16px 16px;

    .news-list {
        height: 223px;
    }
}

.head {
    border-bottom: 2px solid #4a90e2;
    height: 30px;
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    position: relative;
}

.head>.head-text {
    height: 37px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(41, 75, 127, 1);
    line-height: 32px;
    margin-right: 5px;
    /*position: absolute;*/
    /*top: -8px;*/
}

.first-news {
    display: flex;
    margin-bottom: 8px;

    img {
        display: none;
    }
}

.first-news:nth-child(1)>img {
    display: block;
    width: 150px;
    height: 100px;
    margin-right: 10px;
}

.first-news>a {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(51, 51, 51, 1);
    line-height: 21px;
}

.news {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(51, 51, 51, 1);
    line-height: 19px;
    margin: 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.kanshandong {
    width: 65px;
    height: 26px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(41, 75, 127, 1);
    line-height: 26px;
    display: inline-block;
    /*position: absolute;*/
    /*left: 0px;*/
    /*top: -3px;*/
}

.zhanwang-wrap {
    margin: 36px 0;
}

.zhanwang {
    width: 380px;
    height: 100px;
    padding-top: 10px;
    background: #fff;
    margin-bottom: -40px;
    margin-top: 50px;
}

.zhanlue-wrap {
    min-height: 320px;
    width: 370px;
    margin: 16px 0;
}

.zhanlue-text {
    display: block;
    width: 100%;
    text-align: center;
    line-height: 36px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(41, 75, 127, 1);
}

.gundong {
    max-height: 270px;

    /deep/ .swiper-wrapper {
        transition-timing-function: linear !important;
        height: 270px !important;
    }
}

.swiper-slide .swiper-slide-active {
    margin-bottom: 0;
}

.img-swiper {
    width: 370px;
    height: 48px;
    object-fit: contain;
}

.more-news {
    display: inline-block;
    width: 57px;
    height: 19px;
    font-size: 16px;
    font-weight: bold;
    color: #9c9c9c;
    line-height: 25px;
}
</style>